export function parseDateValue(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      const [year, month, day] = trimmed.split('-').map(Number);
      return new Date(year, month - 1, day);
    }

    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
}

export function getDateOnly(value) {
  const date = parseDateValue(value);
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function toDateInputValue(value) {
  return getDateOnly(value);
}

export function toIsoDateTime(value) {
  const date = parseDateValue(value);
  if (!date) return null;
  return date.toISOString();
}

export function formatDatePtBr(value, options = {}) {
  const date = parseDateValue(value);
  if (!date) return '—';

  return date.toLocaleDateString('pt-BR', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...options,
  });
}

export function toIsoUtc(dateTimeLocal) {
  if (!dateTimeLocal) return null;

  return new Date(dateTimeLocal).toISOString();
}